import React from 'react';

import { Box, type XCSS, xcss } from '@atlaskit/primitives';

import { type ListProps, type ListVariant } from './types';

const containerStyles = xcss({
	display: 'flex',
	flexDirection: 'column',
	padding: 'space.0',
	margin: 'space.0',
});

const containerAppearances: Record<ListVariant, XCSS> = {
	rotation: xcss({
		rowGap: 'space.0',
	}),
	participant: xcss({
		rowGap: 'space.050',
	}),
};

const List = ({ children, variant, testId }: ListProps) => {
	return (
		<Box as="ul" testId={testId} xcss={[containerStyles, containerAppearances[variant]]}>
			{children}
		</Box>
	);
};

export { List };
